export const environment = {
  production: true,
  name: 'production',
  urlFront: 'https://sante.meilleurtaux.com',
  domainMTX: '.meilleurtaux.com',
  urlBack: 'https://wazari-afiprod-webapi.azurewebsites.net',
};
